import { Space } from 'antd'
import { CIMSTags } from 'components/CIMSTags'
import { CIMSCollapsePanelOptions } from 'components/CIMSCollapse/types'
import { NameDescription } from './useImplicitPermissions/types'

export const useDSDisciplinesPanel = (
  groups: NameDescription[]
): CIMSCollapsePanelOptions[] =>
  !!groups.length
    ? [
        {
          key: `ds-disciplines-${Math.random()}`,
          header: 'Design Submittals',
          children: (
            <Space direction="vertical" size="small">
              {'Disciplines:'}
              <CIMSTags
                tags={groups.map(({ name, description }) => ({
                  text: name,
                  tooltip: description,
                }))}
              />
            </Space>
          ),
        },
      ]
    : []
